(() => {
  document.addEventListener('click', (event) => {
    const badge = event.target.closest('.jdgm-preview-badge, .jdgm-prev-badge');
    if (!badge || !badge.closest('.product__info-container')) return;
    const reviews = document.getElementById('judgeme_product_reviews') || document.getElementById('as-product-customer-reviews');
    if (!reviews) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, true);
})();
